// import React from "react";

// const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, title }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center">
//       {/* Background Overlay */}
//       <div
//         className="absolute inset-0 bg-black/60 backdrop-blur-sm"
//         onClick={onClose}
//       ></div>

//       {/* Modal */}
//       <div className="relative bg-blue-950 text-white rounded-2xl shadow-2xl w-[90%] max-w-md p-6 animate-scaleIn">
//         <h2 className="mb-3 text-xl font-semibold text-blue-300">
//           Confirm Delete
//         </h2>

//         <p className="mb-6 text-gray-300">
//           Are you sure you want to delete{" "}
//           <span className="font-medium text-blue-400">{title}</span>?  
//           This action cannot be undone.
//         </p>

//         <div className="flex justify-end gap-3">
//           <button
//             onClick={onClose}
//             className="px-4 py-2 transition bg-blue-800 rounded-lg hover:bg-blue-700"
//           >
//             Cancel
//           </button>

//           <button
//             onClick={onConfirm}
//             className="px-4 py-2 transition bg-red-600 rounded-lg hover:bg-red-500"
//           >
//             Delete
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DeleteConfirmModal;

import React from "react";
import { useTheme } from "../../Context/themeContext";
import { AlertTriangle, X, Trash2 } from 'lucide-react';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, title, description }) => {
  const { theme } = useTheme();

  if (!isOpen) return null;

  // Theme-aware styles
  const overlayBg = theme === 'dark'
    ? 'bg-black/60 backdrop-blur-sm'
    : 'bg-black/30 backdrop-blur-sm';

  const modalBg = theme === 'dark'
    ? 'bg-gradient-to-br from-blue-950/95 to-indigo-950/95 border border-blue-500/20'
    : 'bg-gradient-to-br from-white to-gray-50 border border-gray-200';

  const titleColor = theme === 'dark'
    ? 'text-blue-300'
    : 'text-red-600';

  const textColor = theme === 'dark'
    ? 'text-gray-300'
    : 'text-gray-600';

  const highlightColor = theme === 'dark'
    ? 'text-blue-400'
    : 'text-red-600';

  const cancelButton = theme === 'dark'
    ? 'bg-blue-800 hover:bg-blue-700 text-white'
    : 'bg-gray-200 hover:bg-gray-300 text-gray-800';

  const deleteButton = theme === 'dark'
    ? 'bg-red-600 hover:bg-red-500 text-white'
    : 'bg-red-500 hover:bg-red-600 text-white';

  const closeButton = theme === 'dark'
    ? 'text-gray-400 hover:text-white hover:bg-white/10'
    : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Background Overlay */}
      <div
        className={`absolute inset-0 ${overlayBg} transition-all duration-300`}
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className={`relative ${modalBg} rounded-2xl shadow-2xl w-[90%] max-w-md p-6 animate-scaleIn transition-all duration-300`}>
        {/* Close Button */}
        <button
          onClick={onClose}
          className={`absolute top-3 right-3 p-1.5 rounded-lg transition-all duration-200 ${closeButton}`}
          aria-label="Close modal"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Icon */}
        <div className="flex items-center gap-3 mb-4">
          <div className={`p-3 rounded-full ${theme === 'dark' ? 'bg-red-500/20' : 'bg-red-100'}`}>
            <AlertTriangle className={`w-6 h-6 ${theme === 'dark' ? 'text-red-400' : 'text-red-500'}`} />
          </div>
          <h2 className={`text-xl font-semibold ${titleColor}`}>
            Confirm Delete
          </h2>
        </div>

        {/* Message */}
        <div className="mb-6">
          <p className={`${textColor} leading-relaxed`}>
            Are you sure you want to delete{" "}
            <span className={`font-medium ${highlightColor}`}>
              {title}
            </span>
            ? 
          </p>
          {description && (
            <p className={`${textColor} text-sm mt-2 opacity-80`}>
              {description}
            </p>
          )}
          <p className={`${textColor} text-sm mt-3 p-3 rounded-lg ${
            theme === 'dark' ? 'bg-red-500/10 border border-red-500/20' : 'bg-red-50 border border-red-200'
          }`}>
            ⚠️ This action cannot be undone.
          </p>
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className={`px-5 py-2.5 rounded-xl font-medium transition-all duration-200 hover:scale-105 active:scale-95 ${cancelButton}`}
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className={`px-5 py-2.5 rounded-xl font-medium transition-all duration-200 flex items-center gap-2 hover:scale-105 active:scale-95 ${deleteButton}`}
          >
            <Trash2 className="w-4 h-4" />
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;